import React, { useState } from 'react';
import { Heart, Layers, MapPin, Shield, QrCode, History } from 'lucide-react';
import AudienceLayout from './AudienceLayout';
import PersonalRegistrationDialog from '../../components/PersonalRegistrationDialog';

const ForYouPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <AudienceLayout
        color="emerald"
        Icon={Heart}
        eyebrow="VITAL PARA VOCÊ"
        title="Sua saúde. Sua liberdade. Sua Vital."
        subtitle="Escolha seu plano, encontre academias parceiras e tenha acesso a uma experiência completa de saúde e performance."
        heroImage="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=1200&q=80"
        onPrimary={() => setModalOpen(true)}
        onSecondary={() => document.querySelector('[data-testid="for-you-how-it-works"]')?.scrollIntoView({ behavior: 'smooth' })}
        testIdPrefix="for-you"
        steps={[
          { title: 'Faça seu cadastro', desc: 'Preencha seus dados pessoais' },
          { title: 'Aguarde aprovação', desc: 'Nossa equipe revisa em até 24h' },
          { title: 'Receba código de ativação', desc: 'Enviado por WhatsApp e e-mail' },
          { title: 'Faça login na plataforma', desc: 'Com seu e-mail e senha' },
          { title: 'Escolha um plano', desc: 'Pagamento seguro via Stripe' },
          { title: 'Vincule sua academia preferida', desc: 'Rede parceira completa' },
          { title: 'Faça check-ins normalmente', desc: 'Presencial ou via app' },
        ]}
        benefits={[
          { icon: Layers, title: 'Diversos planos', desc: 'Do básico ao premium' },
          { icon: MapPin, title: 'Rede de academias', desc: 'Perto da sua casa ou trabalho' },
          { icon: Heart, title: 'Liberdade de escolha', desc: 'Troque de academia quando quiser' },
          { icon: QrCode, title: 'Check-in digital', desc: 'Rápido, seguro, sem filas' },
          { icon: History, title: 'Histórico de uso', desc: 'Acompanhe sua frequência' },
          { icon: Shield, title: 'Plataforma segura', desc: 'Pagamento e dados protegidos' },
        ]}
        finalCtaTitle="Comece hoje sua jornada Vital."
        finalCtaSubtitle="Cadastre-se agora e comece a treinar em breve."
      />
      <PersonalRegistrationDialog open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default ForYouPage;
